import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}],["path",{"d":"M7 10l6 0","key":"svg-1"}],["path",{"d":"M21 21l-6 -6","key":"svg-2"}]]

/**
 * IconZoomOut
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItem9vbS1vdXQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTMgMTBhNyA3IDAgMSAwIDE0IDBhNyA3IDAgMSAwIC0xNCAwIiAvPgogIDxwYXRoIGQ9Ik03IDEwbDYgMCIgLz4KICA8cGF0aCBkPSJNMjEgMjFsLTYgLTYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/zoom-out
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconZoomOut = createReactComponent('outline', 'zoom-out', 'ZoomOut', __iconNode);

export default IconZoomOut;